module.exports = __webpack_public_path__ + "static/media/trash.53fb4f29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/trash.svg
// module id = 272
// module chunks = 0